import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { App as AntdAppContext, ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
import "./App.scss";
import Init from "./Init";
import "./antstyles.scss";
import { ReactQueryProvider } from "./app/api/ReactQueryProvider";
import { mainTheme } from "./utils/themes";

const App = () => (
  <ReactQueryProvider>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Bebas Neue Pro,sans-serif",
        },
        components: {
          Table: {
            headerBg: "#EAEAEA",
          },
        },
      }}
    >
      <ThemeProvider theme={mainTheme}>
        <AntdAppContext>
          <Init />
        </AntdAppContext>
      </ThemeProvider>
    </ConfigProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </ReactQueryProvider>
);

export default App;
